import React from "react";
import { observer } from "mobx-react";
import { PlatformLinkTypeCreateStore } from "../../store";
import { PlatformLinkTypeCreateForm } from "./PlatformLinkTypeCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PlatformLinkTypeCreateProps = {
  platformLinkTypeCreateStore: PlatformLinkTypeCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PlatformLinkTypeCreate: React.FC<PlatformLinkTypeCreateProps> =
  observer(
    ({ platformLinkTypeCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={platformLinkTypeCreateStore.isSaving} />
          <PlatformLinkTypeCreateForm
            platformLinkTypeCreateStore={platformLinkTypeCreateStore}
            nameError={platformLinkTypeCreateStore.errors.name?.message}
            onNameChange={(value: string) => {
              platformLinkTypeCreateStore.setNameValue(value);
            }}
            name={platformLinkTypeCreateStore.entityValues.name}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={platformLinkTypeCreateStore.isProcessing}
            onSave={() => platformLinkTypeCreateStore.saveNewPlatformLinkType()}
            onCancel={() =>
              platformLinkTypeCreateStore.cancelNewPlatformLinkType()
            }
          />
          <ErrorDialog
            open={platformLinkTypeCreateStore.errorDialogOpened}
            title={platformLinkTypeCreateStore.errorTitle}
            description={platformLinkTypeCreateStore.errorDescription}
            onClose={() => platformLinkTypeCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
